import { useEffect, useState } from 'react'
import CicloEntregaAcoesHttp from '../../../../../services/api/https/deliveries/ciclo-entrega-acoes.http'
import { errorHandler } from '../../../../../services/util/error.service'

export const ETIQUETAGEM_VOLUMES_ACTIONS = {
  LOADING_DELIVERIES: 'LOADING_DELIVERIES',
  NONE: 'NONE',
}

const INITIAL_STATE = {
  deliveries: [],
  deliveriesFiltered: [],
  selecionarTodos: false,
  errorMessage: null,
  loading: ETIQUETAGEM_VOLUMES_ACTIONS.LOADING_DELIVERIES,
  totalDeliveries: 0,
  totalVolumes: 0,
}

export default function useEtiquetagemVolumes(ciclo) {
  const [state, setState] = useState(INITIAL_STATE)

  useEffect(() => {
    async function fetchDeliveries() {
      try {
        const deliveries = await CicloEntregaAcoesHttp.getEtiquetagemVolumesByCicloId(ciclo.id)
        const totalVolumes = deliveries.reduce((total, d) => total + Number(d.qte_volumes || 0), 0)

        setState({
          ...state,
          deliveries,
          deliveriesFiltered: deliveries,
          loading: ETIQUETAGEM_VOLUMES_ACTIONS.NONE,
          totalDeliveries: deliveries.length,
          totalVolumes,
        })
      } catch (error) {
        setState({
          ...state,
          loading: ETIQUETAGEM_VOLUMES_ACTIONS.NONE,
          errorMessage: errorHandler(error),
        })
      }
    }
    ciclo.id && !Number.isNaN(ciclo.id) && fetchDeliveries()
  }, [ciclo.id])

  const totalVolumesSelecionados = state.deliveries
    .filter(d => d.selected)
    .reduce((total, d) => total + Number(d.qte_volumes || 0), 0)

  // Actions
  const actions = {
    onFilterChange(filter) {
      const searchStr = String(filter).toLowerCase()
      const deliveriesFiltered = state.deliveries.filter(delivery => {
        return (
          String(delivery.identifier || '').toLowerCase().includes(searchStr) ||
          String(delivery.client_fantasia || '').toLowerCase().includes(searchStr) ||
          String(delivery.city_name || '').toLowerCase().includes(searchStr) ||
          String(delivery.district || '').toLowerCase().includes(searchStr) ||
          String(delivery.status || '').toLowerCase().includes(searchStr)
        )
      })
      setState(prevState => ({ ...prevState, deliveriesFiltered }))
    },

    onCheckBoxClicked(item, value) {
      const deliveries = state.deliveries.map(d => {
        if (d.delivery_id === item.delivery_id) {
          d.selected = value
        }
        return d
      })
      setState(prevState => ({ ...prevState, deliveries }))
    },

    onSelecionarTodos() {
      const deliveries = state.deliveries.map(item => {
        if (item.qte_volumes > 0) {
          item.selected = !state.selecionarTodos
        }
        return item
      })
      setState(prevState => ({
        ...prevState,
        deliveries,
        selecionarTodos: !state.selecionarTodos,
      }))
    },

    gerarEtiquetas() {
      try {
        const selecionadas = state.deliveries.filter(d => d.selected && d.qte_volumes > 0)
        if (!selecionadas.length) {
          throw new Error('Nenhuma entrega com volumes selecionada')
        }

        const deliveryIds = selecionadas.map(d => d.delivery_id)
        const url = CicloEntregaAcoesHttp.urlReportEtiquetaVolumesEntrega(deliveryIds)
        window.open(url, '_blank')
      } catch (error) {
        setState(prevState => ({ ...prevState, errorMessage: errorHandler(error) }))
      }
    },

    resetMessages() {
      setState(prevState => ({ ...prevState, errorMessage: null }))
    },
  }

  return { state, actions, totalVolumesSelecionados }
}
